<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library as fontAwesomeIconLibrary } from '@fortawesome/fontawesome-svg-core'
import camelCase from 'lodash/camelCase'

// https://fontawesome.com/icons
fontAwesomeIconLibrary.add(
  require('@fortawesome/free-solid-svg-icons/faSync').definition,
  require('@fortawesome/free-solid-svg-icons/faUser').definition,
  require('@fortawesome/free-solid-svg-icons/faUserPlus').definition,
  require('@fortawesome/free-solid-svg-icons/faUsers').definition,
  require('@fortawesome/free-solid-svg-icons/faSpinner').definition,
  require('@fortawesome/free-solid-svg-icons/faEye').definition,
  require('@fortawesome/free-solid-svg-icons/faEyeSlash').definition,
  require('@fortawesome/free-solid-svg-icons/faChevronUp').definition,
  require('@fortawesome/free-solid-svg-icons/faChevronDown').definition,
  require('@fortawesome/free-solid-svg-icons/faChevronLeft').definition,
  require('@fortawesome/free-solid-svg-icons/faChevronRight').definition,
  require('@fortawesome/free-solid-svg-icons/faLock').definition,
  require('@fortawesome/free-solid-svg-icons/faSignOutAlt').definition,
  require('@fortawesome/free-solid-svg-icons/faCog').definition,
  require('@fortawesome/free-solid-svg-icons/faTimes').definition,
  require('@fortawesome/free-solid-svg-icons/faArrowLeft').definition,
  require('@fortawesome/free-solid-svg-icons/faArrowRight').definition,
  require('@fortawesome/free-solid-svg-icons/faArrowRightLong').definition,
  require('@fortawesome/free-solid-svg-icons/faShieldHalved').definition,
  require('@fortawesome/free-solid-svg-icons/faPlus').definition,
  require('@fortawesome/free-solid-svg-icons/faBuilding').definition,
  require('@fortawesome/free-solid-svg-icons/faBuildingUser').definition,
  require('@fortawesome/free-solid-svg-icons/faGraduationCap').definition,
  require('@fortawesome/free-solid-svg-icons/faCheck').definition,
  require('@fortawesome/free-solid-svg-icons/faXmark').definition,
  require('@fortawesome/free-solid-svg-icons/faStar').definition,
  require('@fortawesome/free-regular-svg-icons/faStar').definition,
  require('@fortawesome/free-solid-svg-icons/faFlag').definition,
  require('@fortawesome/free-solid-svg-icons/faUtensils').definition,
  require('@fortawesome/free-solid-svg-icons/faShareSquare').definition,
  require('@fortawesome/free-solid-svg-icons/faLink').definition
)

export default {
  components: {
    FontAwesomeIcon,
  },
  inheritAttrs: false,
  props: {
    source: {
      type: String,
      default: 'font-awesome',
    },
    name: {
      type: [String, Object],
      required: true,
    },
  },
  computed: {
    // Gets a CSS module class, e.g. iconCustomLogo
    customIconClass() {
      return this.$style[camelCase('icon-custom-' + this.name)]
    },
  },
}
</script>

<template>
  <FontAwesomeIcon v-if="source === 'font-awesome'" v-bind="$attrs" :icon="name" />
  <span v-else-if="source === 'custom'" v-bind="$attrs" :class="customIconClass" />
</template>
